<template>
  <div class="entryHomeContainer">
    <div class="entryHeader">
      <div class="entryHeaderLeft"></div>
      <div class="entryHeaderRight">
        <div class="userInfo">{{userInfo.name}}，欢迎使用！</div>
        <div @click="goSelf()" class="backSelf" v-if="runAsOther">
          <div class="dropdownMenuName">
            <Icon type="md-swap"></Icon>返回
          </div>
        </div>
        <div class="logout">
          <!-- <Tooltip size='small' content='退出' transfor> -->
          <Icon @click="logout" class="logout" type="md-power" />
          <!-- </Tooltip> -->
        </div>
      </div>
    </div>
    <div class="swiperMain">
      <Carousel :autoplay="false" dots="none">
        <CarouselItem :key="idex" v-for="idex in parseInt(userEntries.length / partNum) + 1">
          <div class="entryItemLine">
            <template v-for="subInx in 5">
              <div
                :key="subInx+'-index'"
                @click="toEntry(userEntries[(idex -1 )*partNum + (subInx - 1)])"
                class="entryItem"
                v-if="((idex -1 )*partNum + subInx) <= userEntries.length"
              >
                <img
                  :src="userEntries[(idex -1 )*partNum + (subInx - 1)].iconPathMock"
                  @error="onerrorLogo"
                  class="entryIcon"
                />
                <p class="entryName">{{userEntries[(idex -1 )*partNum + (subInx - 1)].name}}</p>
              </div>
            </template>
          </div>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="entryCopyright">{{systemInfo.copyRight}}</div>
  </div>
</template>

<script>

export default {
  name: 'entry',
  data () {
    return {
      partNum: 5,
      loginForm: {},
      projectInfo: {},
      configIcon: require('@/assets/static/images/config.png')
    }
  },
  computed: {
    runAsOther: function () {
      return this.$store.getters['userInfo/runAsOther'] || false
    },
    systemInfo: function () {
      return this.$store.getters['systemInfo/systemInfo']
    },
    userEntries: function () {
      let entries = this.$store.getters['menuInfo/userEntries'] || []
      entries.forEach(element => {
        if (element.iconPath) {
          element.iconPathMock = this.$store.getters['systemSupport/systemSupport']?.file + element.iconPath
        } else {
          element.iconPathMock = this.$common.basePath + "static/images/config.png"
        }
      })
      return entries
    },
    userInfo: function () {
      return this.$store.getters['userInfo/user'] || {}
    },
    entryMenus: function () {
      return this.$store.getters['menuInfo/entryMenus'] || {}
    },

  },
  methods: {
    onerrorLogo: function (e) {
      e.target.src = this.configIcon
      e.target.onerror = null
      // return (
      //   "javascript:this.src='" + this.$common.basePath + "';"
      // )
    },

    toEntry: function (entry) {
      if (entry.needToken) {
        let token = this.$store.getters.token
        console.log('token', token)
        if (entry.isExtraLink) {
          //若外链接 直接跳转
          if (entry.path.indexOf('?') >= 0) {
            window.open(entry.path + "&token=" + token, '_' + entry.pageOpenType)
          } else {
            window.open(entry.path + '?token=' + token, '_' + entry.pageOpenType)
          }
        } else {
          this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'entryCode', value: entry.code })
          // 有子菜单 默认跳转第一个 
          let defaultUrl = this.$store.getters['userInfo/defaultUrl']
          if (defaultUrl) {
            this.$router.push({ path: defaultUrl, query: { token: token } })
          } else if (Object.keys(this.entryMenus).length > 0) {
            let openMenu = this.entryMenus[Object.keys(this.entryMenus)[0]][0]
            if (openMenu.children && openMenu.children.length > 0) {
              this.$router.push({ name: openMenu.children[0].pathName, query: { token: token } })
            } else {
              let pathName = openMenu.pathName
              this.$router.push({ name: pathName, query: { token: token } })
            }
          } else {
            // this.$router.push({name: entry.code + 'Entry'});
            this.$router.push({ path: '/unAuthorized', query: { token: token } })
            this.$Message.warning("请通知管理员分配菜单权限！")
          }
        }
      } else {
        if (entry.isExtraLink) {
          //若外链接 直接跳转
          window.open(entry.path, '_' + entry.pageOpenType)
        } else {
          this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'entryCode', value: entry.code })
          // 有子菜单 默认跳转第一个 
          let defaultUrl = this.$store.getters['userInfo/defaultUrl']
          if (defaultUrl) {
            this.$router.push({ path: defaultUrl })
          } else if (Object.keys(this.entryMenus).length > 0) {
            let openMenu = this.entryMenus[Object.keys(this.entryMenus)[0]][0]
            if (openMenu.children && openMenu.children.length > 0) {
              this.$router.push({ name: openMenu.children[0].pathName })
            } else {
              let pathName = openMenu.pathName
              this.$router.push({ name: pathName })
            }
          } else {
            // this.$router.push({name: entry.code + 'Entry'});
            this.$router.push({ path: '/unAuthorized' })
            this.$Message.warning("请通知管理员分配菜单权限！")
          }
        }
      }

    },
    logout: function () {
      this.$bus.$emit('logout', true)
    },
    // 返回本身账号
    goSelf: function () {
      this.$bus.$emit('backSelf')
    },
    loadUserEntries: function (needChange) {
      console.log("loadUserEntries...")
      let that = this
      that.$axios.post(this.$apis.systemManager.userManager.getUserEntries).then(res => {
        if (res.success) {
          //入口
          let projectEntries = res.result.projectEntries || []
          this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'userEntries', value: projectEntries })
          if (projectEntries.length == 0) {
            that.$Message.warning("尚未分配入入口权限，请联系管理员处理！")
          }
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error('加载用户入口信息失败！')
      })
    },
  },
  beforeMount () {

    this.loadUserEntries()
  }
}
</script>
<style lang="less" scoped>
.entryHomeContainer {
  display: flex;
  align-content: center;
  padding: 0 10vw;
  justify-items: center;
  overflow: hidden;
  cursor: default;

  .entryHeader {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.1);
    color: #f2f2f2;
    justify-content: space-between;
    padding: 1rem;

    .entryHeaderRight {
      display: flex;
      justify-content: right;
      align-items: center;

      div {
        margin: auto 5px;
      }

      .userInfo,
      .backSelf {
        font-size: 0.8rem;
        color: #f2f2f2;
      }

      .backSelf {
        cursor: pointer;
      }

      .logout {
        font-size: 1.2rem;
        opacity: 0.6;
        color: #f2f2f2;
        cursor: pointer;
      }

      .logout:hover {
        opacity: 0.8;
        transform: scale(1.1);
      }
    }
  }

  .swiperMain {
    margin: auto;
    width: 100%;

    .entryItemLine {
      display: flex;
      justify-content: center;

      .entryItem {
        overflow: hidden;
        cursor: pointer;
        flex: 1;
        max-width: 15rem;

        flex-direction: column;
        height: 200px;
        color: #f2f2f2;
        margin: 2rem;
        display: flex;
        background-image: url('./static/entryWithPage/images/entry_item.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        box-shadow: 1px 1px 7px #0043a6;
        border-radius: 5px;
        padding: 2rem;
        justify-content: center;
        transition: all 0.15s ease-in;

        .entryItem:hover {
          background-color: rgba(0, 0, 0, 0.05);
          transform: scale(1.2);
        }

        .entryName {
          font-size: 1rem;
          font-weight: 600;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .entryIcon {
          width: 5rem;
          height: 5rem;
          margin: auto;
          /* background-image: url(./static/images/config.png); */
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
        }
      }
    }
  }

  .entryCopyright {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1rem;
    color: #f2f2f2;
    font-size: 0.75rem;
    text-align: center;
  }
}
</style>